import { ajax } from '@/util/ajax'

const BASE_URL = '/gateway/platform-lmsapi/api/right-panel'

const RightPanelApi = {
  submitAuditRecord (data, success, failure) {
    return ajax.post(
      BASE_URL + '/submit-audit-record',
      data,
      success,
      failure
    )
  },

  discardAuditRecord (data, success, failure) {
    return ajax.post(
      BASE_URL + '/discard-audit-record',
      data,
      success,
      failure
    )
  },

  listAuditRecordDetails (loanId, success, failure) {
    return ajax.get(
      BASE_URL + '/list-audit-details',
      {
        loanId: loanId
      },
      success,
      failure
    )
  }
}

export { RightPanelApi }
